function escapeHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function parsePrinterBinaryData(base64: string): string {
  const binaryStr = atob(base64);
  const bytes = new Uint8Array(binaryStr.length);
  for (let i = 0; i < binaryStr.length; i++) {
    bytes[i] = binaryStr.charCodeAt(i);
  }

  // Each Novitus record: 6-byte header + 44 bytes of line data (windows-1250)
  // Header: [byte with bit 7 set] [heightCtrl] [widthCtrl] [0xC2] [0x2C] [formatChar]
  // heightCtrl: 0x20 = double-width + double-height (DO ZAPŁATY)
  // widthCtrl:  0x40 = double-width only (SUMA)
  // formatChar: 0x21='!' centered, 0x28='(' footer, 0x20=' ' left-aligned
  const decoder = new TextDecoder('windows-1250');
  const parts: string[] = [];

  for (let i = 0; i + 6 < bytes.length; i++) {
    if (!(bytes[i] & 0x80)) {
      continue;
    }
    const heightCtrl = bytes[i + 1];
    const widthCtrl = bytes[i + 2];
    const formatChar = bytes[i + 5];
    const isCentered = formatChar === 0x21; // '!'

    const rawText = isCentered
      ? decoder.decode(bytes.slice(i + 6, i + 52)).trim()
      : decoder.decode(bytes.slice(i + 6, i + 52)).trimEnd();

    if (/^[~=\-*]+$/.test(rawText.trim())) {
      parts.push('<hr class="jpk-hr">');
    } else if (heightCtrl === 0x20) {
      // extra-large (DO ZAPŁATY): 2× width + 2× height → font-size:2em
      parts.push(
        `<div class="jpk-line jpk-line-xl${isCentered ? ' jpk-centered' : ''}">${escapeHtml(rawText || ' ')}</div>`,
      );
    } else if (widthCtrl === 0x40) {
      // double-width only (SUMA): same height, 2× wider → scaleX(2) on a 50%-wide inner div
      parts.push(
        `<div class="jpk-line-dw">` +
          `<div class="jpk-line jpk-line-dw-inner${isCentered ? ' jpk-centered' : ''}">${escapeHtml(rawText || ' ')}</div></div>`,
      );
    } else if (formatChar === 0x29 || formatChar === 0x24) {
      // unknown
    } else {
      parts.push(
        `<div class="jpk-line${isCentered ? ' jpk-centered' : ''}">${escapeHtml(rawText || ' ')}</div>`,
      );
    }

    i += 49; // skip to end of this record (loop i++ will land on next byte)
  }

  return parts.join('');
}
